var table_viewer_default = {
  "viewMode": "_4w-Ce",
  "editMode": "_8wTk6",
  "container": "spkt3",
  "cell": "MqbZI"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
